import clsx from 'clsx';
import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import type { ButtonHTMLAttributes } from 'react';
import React from 'react';

type Props = {
    day: Dayjs;
    isSelected: boolean;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export function CalendarDayCell({ day, isSelected, ...props }: Props) {
    return (
        <button
            className={clsx('cell', {
                cell_selected: isSelected,
                cell_gray: !day.isSame(dayjs(), 'month'),
            })}
            {...props}
        >
            {day.date()}
        </button>
    );
}
